import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './interactive-share-chart.component.scss';
var InteractiveShareChart = /** @class */ (function (_super) {
    tslib_1.__extends(InteractiveShareChart, _super);
    function InteractiveShareChart(element) {
        return _super.call(this, element) || this;
    }
    InteractiveShareChart.prototype.init = function () {
    };
    InteractiveShareChart.prototype.bindEvents = function () {
    };
    return InteractiveShareChart;
}(Base));
export { InteractiveShareChart };



//////////////////
// WEBPACK FOOTER
// ./components/interactive-share-chart/interactive-share-chart.component.ts
// module id = 712
// module chunks = 0